import { render, staticRenderFns } from "./ItemCreate.vue?vue&type=template&id=49942d5c"
import script from "../../controllers/item/item-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/item/item-create.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports